import React from "react";
import { Paths, Urls } from "../constants/UrlConstants";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import styles from "../assets/css/modules/myprofile/myprofilecommunicationprefs.css";


const MyProfileCommunicationNeeds = {
  UpdateButton: "Save Changes",
  CommSection: {
    HomeHeading: "Communication support options",
    HomeSubheading: (
      <React.Fragment>
        <p>
        Choose the way you’d like to hear from us and we’ll make a note on your account.
        </p>
        <p>
        We aim to provide your documents and other information in your chosen way as soon as possible but please allow up to 10 days for braille to be produced.
        </p>
      </React.Fragment>),
    HomeFirstSubheading: (
      <React.Fragment>
        <p classname={styles.homeFirstSubheading} style={{  fontSize: "20px"}}>
          Would you like to receive your documents in any of these formats?
        </p>
      </React.Fragment>),
    HomeSecondSubheading: (
      <React.Fragment>
        <p classname={styles.homeFirstSubheading} style={{  fontSize: "20px"}}>
          Would you like to use any of these services when communicating with us?
        </p>
      </React.Fragment>),

      HomeFirstSubheadingDescription:(
      <React.Fragment>
        <p>You can select <strong>one</strong> of the options below</p>
      </React.Fragment>),

    Heading: "My communication needs",
    Subheading: (
      <React.Fragment>
        <p>
          If you need help to access information, we can provide communications in various ways.
          Just choose the way you'd like to hear from us from this list below and we'll make a
          note on your account.
        </p>
        <p>
          You should start to receive future communications in the way you've chosen. If you
          don't, let us know and we can resend it. We aim to provide your communications as soon
          as possible but Braille will take longer as it takes over 10 days to produce.
        </p>
      </React.Fragment>
    ),
  },
  HelpSection: {
    HeadingLinkTo: Paths.Help,
    HeadingLinkText: "Help",
    MoreHelpLinkTo: Paths.Help,
    MoreHelpLinkText: "View more help",
    Faq: [
      {
        Question:
          "What will happen when I update my communication preferences?",
        Answer: {
          Any: (
            <React.Fragment>
              <p>
                When you update your preferences, all future membership
                documents and claims information will be sent to you by your
                chosen preference.
              </p>
              {/* <p>
                When you choose online, there will be some occasions when we
                send you a paper copy too, as we'll also need to send you
                something else relevant to the claim - e.g. a cheque.
              </p> */}
            </React.Fragment>
          )
        }
      },
      {
        Question: "Why I am still receiving documents by post?",
        Answer: {
          Any: (
            <p>
              Although you have chosen your preference as online, there are
              occasions when we need to send you other information - e.g. a
              cheque.
            </p>
          )
        }
      },
      {
        Question: "Can I receive my documents by post as well as online?",
        Answer: {
          Any: (
            <p>
              Yes, if you choose the post option all your documents will be
              posted to you, but the information will also be available online.
            </p>
          )
        }
      },
      {
        Question: "Can you send me information in alternative ways ?",
        Answer: {
          Any: (
            <p>
              We can provide communications in various ways to help you access the
              communications we send you. Just go to the 'My communication needs' tab
              and select the option  you need.  You should start to receive future
              communications in the way you've chosen. If you don't, let us know and
              we can resend it.
            </p>
          )
        }
      },
      {
        Question: "Are my contact options the same as marketing preferences?",
        Answer: {
          Any: (
            <p>
              When you confirm your contact preferences you are letting us know how we
              can contact you about your existing plan so that we can help you use all its
              features. These contact options are not the same as marketing preferences which
              would allow us to tell you about other products and services.
            </p>
          )
        }
      }
    ]
  },
  CommSectionSubheading:{
    1:"A way for people with sight loss to 'read' information by touch.",
    2:"This service provides printed documents in larger wording for easier reading.",
    3:"A CD provides spoken documents if you have sight loss.",
    4:"Talk to us via sign language service if you are deaf or have hearing loss.",
    5:"This option uses coloured paper, easy to read font, and accessible layouts.", //Dyslexic print
    6:"",
    7:(<React.Fragment>Talk to us by text or textphone by joining {" "}
    {" "}
    <a
    className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          href={Urls.RelayUK}
          rel="noopener noreferrer"
          target="_blank"
          >Relay UK's service </a>
          if you're deaf or have hearing loss.</React.Fragment>)    
  },
  Errors: {
    PreferenceUpdateFailed:
      "There was an error processing your update, please try again later.",
    GetMasterDataFailed: "Sorry, something went wrong. Please try again.",
    PersonNotFoundError: "Communication needs is not available for this member.",
  },
  SaveCommPreferenceSuccess: "Thanks for confirming your communications needs.  We've made a note of these.",
  SaveCommPreferenceError: "Sorry, something went wrong. Please try again.",
  noSelectionCommPreferenceError: "Thank you for confirming that you don't need communication support.",
  NoChangesMessage: "Thanks you. You have chosen to not change your options.",
  PreferenceUpdateSucceeded: "Thank you, your preference has been updated.",
  ContactPreferencesUpdateSucceeded:
    "Thank you for letting us know how you'd like us to contact you. It's all done, but if you've asked us to stop any of our updates, we may not be able to stop any that are already on their way to you.",
  OnboadingHeading: {
    NoThanks: "I don’t need any of these options.",
    DocumentsInBraille: "A way for people with sight loss to 'read' information by touch.",
    DocumentsInLargePrint: "This service provides printed documents in larger wording for easier reading.",
    Audio: "A CD provides spoken documents if you have sight loss.",
    Dyslexicprint:"This option uses coloured paper, easy to read font, and accessible layouts.",
    SignLanguageService: "Talk to us via this sign language service if you are deaf or have hearing loss.",
    RelayUK: (
      <React.Fragment>Talk to us by text or textphone by joining {" "}
        {" "}
        <a
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          href={Urls.RelayUK}
          rel="noopener noreferrer"
          target="_blank"
        > Relay UK's service </a>
        if you're deaf or have hearing loss.</React.Fragment>)
  },
  OnboadingDescription: {
    DocumentsInBraille: "You’ve told us you want to receive your documents in braille.",
    DocumentsInLargePrint: "You’ve told us you want to receive your documents in large print.",
    Audio: "You’ve told us you want to our audio service for spoken content.",
    SignLanguageService: "You’ve told us you want to use our sign language service when communicating with us.",
    RelayUK: "You’ve told us you want to use the Relay UK service when you communicate with us.",
    Dyslexicprint:"You've told us you want to receive your documents in Dyslexic print"
  },
  OnboadingConfirmation: "Is this correct?",
  CommNeedsSection: {
    HomeHeading: "Do you have communication support needs?",
    HomeSubheading:
      <React.Fragment>
        <p>
          Let us know if you need any help with accessing information. We have a range of options available if you have hearing or sight loss.
        </p>
      </React.Fragment>
  },
  NoChangesSelectionMessage: "Select if you would like to receive your documents in any of these formats",
  NoChangesSelectionServiceMessage: "Select if you require this service or not"
};

export default MyProfileCommunicationNeeds;
